import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { supabase } from '../lib/supabase'
import { getDashboardPath } from '../services/auth.service'
import { profileToUser } from '../services/auth.service'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    const handle = async () => {
      // Supabase picks up the token from the URL hash automatically
      const { data: { session }, error } = await supabase.auth.getSession()

      if (error || !session) {
        navigate('/login', { replace: true })
        return
      }

      // Fetch profile
      const { data: profile } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', session.user.id)
        .single()

      if (!profile) {
        // Profile may not exist yet (first Google login) — wait for trigger
        await new Promise(r => setTimeout(r, 1500))
        const { data: profile2 } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', session.user.id)
          .single()

        if (profile2) {
          // Store Google tokens
          if (session.provider_token) {
            await supabase.from('profiles').update({
              google_provider_token: session.provider_token,
              google_refresh_token:  session.provider_refresh_token ?? null,
            }).eq('id', session.user.id)
          }
          const user = profileToUser(profile2, session.user.email)
          navigate(getDashboardPath(user.role), { replace: true })
        } else {
          navigate('/dashboard', { replace: true })
        }
        return
      }

      // Store Google tokens
      if (session.provider_token) {
        await supabase.from('profiles').update({
          google_provider_token: session.provider_token,
          google_refresh_token:  session.provider_refresh_token ?? null,
        }).eq('id', session.user.id)
      }

      const user = profileToUser(profile, session.user.email)
      navigate(getDashboardPath(user.role), { replace: true })
    }

    handle()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#000' }}>
      <div className="flex flex-col items-center gap-3">
        <Loader2 size={28} className="animate-spin" style={{ color: '#ffc600' }} />
        <p className="text-sm" style={{ color: '#555', fontFamily: 'DM Sans, sans-serif' }}>
          Signing you in…
        </p>
      </div>
    </div>
  )
}
